import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Session, Conversation } from '../../types/models';

interface SessionState {
  sessions: Session[];
  currentSession: Session | null;
  loading: boolean;
  error: string | null;
}

const initialState: SessionState = {
  sessions: [],
  currentSession: null,
  loading: false,
  error: null,
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    fetchSessionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSessionsSuccess: (state, action: PayloadAction<Session[]>) => {
      state.sessions = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSessionSuccess: (state, action: PayloadAction<Session>) => {
      state.currentSession = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSessionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    startSessionSuccess: (state, action: PayloadAction<Session>) => {
      state.currentSession = action.payload;
      state.sessions.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updateSessionSuccess: (state, action: PayloadAction<Session>) => {
      state.sessions = state.sessions.map(session => 
        session.sessionId === action.payload.sessionId ? action.payload : session
      );
      if (state.currentSession && state.currentSession.sessionId === action.payload.sessionId) {
        state.currentSession = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    endSessionSuccess: (state, action: PayloadAction<Session>) => {
      state.sessions = state.sessions.map(session => 
        session.sessionId === action.payload.sessionId ? action.payload : session
      );
      if (state.currentSession && state.currentSession.sessionId === action.payload.sessionId) {
        state.currentSession = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    clearSessionError: (state) => {
      state.error = null;
    },
    clearCurrentSession: (state) => {
      state.currentSession = null;
    },
  },
});

export const {
  fetchSessionsStart,
  fetchSessionsSuccess,
  fetchSessionSuccess,
  fetchSessionFailure,
  startSessionSuccess,
  updateSessionSuccess,
  endSessionSuccess,
  clearSessionError,
  clearCurrentSession,
} = sessionSlice.actions;

export default sessionSlice.reducer;
